<template>
  <CCard v-if="orderItems.length > 0" class="mb-4">
    <CCardHeader>
      <h5 class="mb-0">
        <CIcon name="cipList" class="mr-2"/>
        <translate translate-context="edge-orders.detail">Order Items</translate>
      </h5>
    </CCardHeader>
    <CCardBody class="p-0">
      <CDataTable
        :items="orderItems"
        :fields="fields"
        hover
        striped
        border
      >
        <template #product="{item}">
          <td>
            <!-- Bundle -->
            <template v-if="item.isBundleGroup">
              <CIcon name="cilLayers" class="text-secondary mr-2"/>
              <strong>{{ item.bundle.name }}</strong>
              <CBadge color="primary" class="ml-2">
                <translate translate-context="orderitemstable.product">Bundle</translate>
              </CBadge>
              <div v-if="item.bundle.description" class="small text-muted">
                {{ item.bundle.description }}
              </div>
              <!-- List bundle items -->
              <div class="mt-2 ml-4">
                <div v-for="bundleItem in item.bundleItems" :key="bundleItem.id" class="small text-muted">
                  <CIcon
                    :name="bundleItem.is_printable ? 'cilPrint' : 'cilCloudDownload'"
                    :class="bundleItem.is_printable ? 'text-primary' : 'text-info'"
                    size="sm"
                    class="mr-1"
                  />
                  {{ getProductName(bundleItem) }}
                  <span v-if="bundleItem.product_variant && bundleItem.product_variant.name">
                    - {{ bundleItem.product_variant.name }}
                  </span>
                </div>
              </div>
            </template>

            <!-- Regular item -->
            <template v-else>
              <CIcon
                :name="item.is_printable ? 'cilPrint' : 'cilCloudDownload'"
                :class="item.is_printable ? 'text-primary' : 'text-info'"
                class="mr-2"
              />
              <a
                :href="`#order-item-${item.id}`"
                class="order-item-link"
                @click.prevent="scrollToOrderItem(item.id)"
              >
                <strong>{{ getProductName(item) }}</strong>
              </a>
              <div v-if="item.product_variant && item.product_variant.name" class="small text-muted">
                {{ item.product_variant.name }}
              </div>
            </template>
          </td>
        </template>
        <template #quantity="{item}">
          <td class="text-center">
            {{ item.quantity }}
          </td>
        </template>
        <template #photos="{item}">
          <td class="text-center">
            <!-- Bundle: sum media count from all items -->
            <template v-if="item.isBundleGroup">
              {{ getBundleMediaCount(item) }}
            </template>
            <!-- Regular item -->
            <template v-else>
              {{ getMediaCount(item) }}
            </template>
          </td>
        </template>
        <template #unit_price="{item}">
          <td class="text-right">
            {{ item.unit_price | currency(order.currency) }}
          </td>
        </template>
        <template #total="{item}">
          <td class="text-right">
            <strong>{{ item.total_price | currency(order.currency) }}</strong>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
  </CCard>
</template>

<script>
import Filters from '@/domain/core/utils/filters'

export default {
  name: 'OrderItemsTable',
  props: {
    orderItems: {
      type: Array,
      required: true
    },
    order: {
      type: Object,
      required: true
    },
    getMediaCount: {
      type: Function,
      required: true
    }
  },
  computed: {
    fields() {
      return [
        { key: 'product', label: this.$pgettext('edge-orders.detail', 'Product') },
        { key: 'quantity', label: this.$pgettext('edge-orders.detail', 'Qty'), _classes: 'text-center' },
        { key: 'photos', label: this.$pgettext('edge-orders.detail', 'Photos'), _classes: 'text-center' },
        { key: 'unit_price', label: this.$pgettext('edge-orders.detail', 'Unit Price'), _classes: 'text-right' },
        { key: 'total', label: this.$pgettext('edge-orders.detail', 'Total'), _classes: 'text-right' }
      ]
    }
  },
  methods: {
    getProductName(item) {
      if (item.bundle) {
        return item.bundle.name
      } else if (item.product) {
        return item.product.name
      }
      return '-'
    },
    getBundleMediaCount(bundleGroup) {
      // Sum media count from all items in the bundle
      let total = 0
      if (bundleGroup.bundleItems) {
        bundleGroup.bundleItems.forEach(item => {
          const count = this.getMediaCount(item)
          if (count !== '-') {
            total += count
          }
        })
      }
      return total > 0 ? total : '-'
    },
    scrollToOrderItem(itemId) {
      const element = document.getElementById(`order-item-${itemId}`)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }
  },
  filters: {
    currency: Filters.currency
  }
}
</script>

<style scoped>
.order-item-link {
  color: #321fdb;
  text-decoration: none;
  cursor: pointer;
}

.order-item-link:hover {
  color: #2819a0;
  text-decoration: underline;
}
</style>
